"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _downshift = _interopRequireDefault(require("downshift"));
var R = _interopRequireWildcard(require("ramda"));
var _formik = require("formik");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _pluralTranslations = require("../../../../localization/pluralTranslations");
var _config = require("../../../../services/config");
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _Counter = require("../../../ui/Counter");
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var MIN_ADULTS = 1;
var MAX_ADULTS = 8;
var MAX_CHILDREN = 3;
var MIN_CHILDREN_AGE = 1;
var MAX_CHILDREN_AGE = 16;
var AGES = R.range(MIN_CHILDREN_AGE, R.inc(MAX_CHILDREN_AGE));
var TouristsControl = function TouristsControl() {
  var _getTouristsControlIn;
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var yearsTranslations = (0, _pluralTranslations.usePluralYearsTranslation)();
  var buttonProps = (_getTouristsControlIn = (0, _config.getTouristsControlInSearchForm)()) !== null && _getTouristsControlIn !== void 0 ? _getTouristsControlIn : {};
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.row
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.adultsCol
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t('ADULTS_CONTROL_LABEL')
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _fn.QUERY_PARAMS.ADULTS,
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react.default.createElement(_Counter.Counter, {
        buttonProps: buttonProps,
        max: MAX_ADULTS,
        min: MIN_ADULTS,
        value: field.value,
        onDecrease: function onDecrease(next) {
          form.setFieldValue(field.name, next);
        },
        onIncrease: function onIncrease(next) {
          form.setFieldValue(field.name, next);
        }
      });
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.childrenCol
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t('CHILD_CONTROL_LABEL')
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _fn.QUERY_PARAMS.CHILDREN,
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.childrens
      }, R.addIndex(R.map)(function (age, index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.children,
          key: index
        }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
          width: _Button.WIDTHS.FLUID,
          size: _Button.SIZES.TINY,
          theme: _Button.THEMES.GRAY,
          onClick: function onClick() {
            return form.setFieldValue(field.name, R.addIndex(R.filter)(function (_, ownIndex) {
              return ownIndex !== index;
            }, field.value));
          }
        }, buttonProps), /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.childrenInner
        }, "".concat(age, " ").concat(yearsTranslations(age)), /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.remove
        }, "\xD7"))));
      }, field.value), /*#__PURE__*/_react.default.createElement(_downshift.default, null, function (_ref3) {
        var isOpen = _ref3.isOpen,
          closeMenu = _ref3.closeMenu,
          toggleMenu = _ref3.toggleMenu;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.dropdownContainer
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.childrenButton
        }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
          width: _Button.WIDTHS.FLUID,
          disabled: field.value.length === MAX_CHILDREN,
          size: _Button.SIZES.TINY,
          theme: _Button.THEMES.GRAY,
          onClick: toggleMenu
        }, buttonProps), t('OPEN_CHILD_POPUP_BUTTON'))), isOpen && /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.dropdownBody
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.childrenTitle
        }, t('CHILD_POPUP_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.dropdownList
        }, R.map(function (age) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: _styles.default.dropdownItem,
            key: age
          }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
            className: _styles.default.dropdownItem__button,
            width: _Button.WIDTHS.FLUID,
            theme: _Button.THEMES.GRAY,
            onClick: field.value.length !== MAX_CHILDREN ? function () {
              return form.setFieldValue(field.name, R.append(age, field.value)), closeMenu();
            } : undefined
          }, buttonProps), age));
        }, AGES))));
      }));
    }
  })));
};
var _default = exports.default = (0, _react.memo)(TouristsControl);